import { differenceInYears } from 'date-fns';

var AutoFillSourceVehicle;
(function (AutoFillSourceVehicle) {
    AutoFillSourceVehicle["None"] = "None";
    AutoFillSourceVehicle["AutoTech"] = "AutoTech";
})(AutoFillSourceVehicle || (AutoFillSourceVehicle = {}));
var Gender;
(function (Gender) {
    Gender["None"] = "None";
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
})(Gender || (Gender = {}));
var VehicleStill;
(function (VehicleStill) {
    VehicleStill["NotApplicable"] = "NotApplicable";
    VehicleStill["Parked"] = "Parked";
    VehicleStill["Still"] = "Still";
})(VehicleStill || (VehicleStill = {}));
var VehicleStarting;
(function (VehicleStarting) {
    VehicleStarting["NotApplicable"] = "NotApplicable";
    VehicleStarting["Starting"] = "Starting";
    VehicleStarting["OpenedDoor"] = "OpenedDoor";
})(VehicleStarting || (VehicleStarting = {}));
var CollisionTouchType;
(function (CollisionTouchType) {
    CollisionTouchType["None"] = "None";
    CollisionTouchType["Car"] = "Car";
    CollisionTouchType["MC"] = "MC";
    CollisionTouchType["Trailer"] = "Trailer";
})(CollisionTouchType || (CollisionTouchType = {}));
var VehicleKey;
(function (VehicleKey) {
    VehicleKey["A"] = "A";
    VehicleKey["B"] = "B";
})(VehicleKey || (VehicleKey = {}));
var AutoFillSourceContact;
(function (AutoFillSourceContact) {
    AutoFillSourceContact["None"] = "None";
    AutoFillSourceContact["CustomerSearch"] = "CustomerSearch";
    AutoFillSourceContact["ExternalCustomerSearch"] = "ExternalCustomerSearch";
})(AutoFillSourceContact || (AutoFillSourceContact = {}));
var DocumentSignatureSectionType;
(function (DocumentSignatureSectionType) {
    DocumentSignatureSectionType["Manual"] = "Manual";
    DocumentSignatureSectionType["Digital"] = "Digital";
})(DocumentSignatureSectionType || (DocumentSignatureSectionType = {}));
var MessageMedium;
(function (MessageMedium) {
    MessageMedium["None"] = "None";
    MessageMedium["Email"] = "Email";
    MessageMedium["Sms"] = "Sms";
})(MessageMedium || (MessageMedium = {}));
var AccidentReportPage;
(function (AccidentReportPage) {
    AccidentReportPage["PageOne"] = "PageOne";
    AccidentReportPage["PageTwo"] = "PageTwo";
})(AccidentReportPage || (AccidentReportPage = {}));

var SigningMethod;
(function (SigningMethod) {
    SigningMethod["Handwritten"] = "Handwritten";
    SigningMethod["BankID"] = "BankID";
})(SigningMethod || (SigningMethod = {}));
var SignatureStatus;
(function (SignatureStatus) {
    SignatureStatus["None"] = "None";
    SignatureStatus["Signed"] = "Signed";
    SignatureStatus["Declined"] = "Declined";
})(SignatureStatus || (SignatureStatus = {}));

var _a;
var FigureId;
(function (FigureId) {
    FigureId["CarA"] = "carA";
    FigureId["CarB"] = "carB";
    FigureId["McA"] = "mcA";
    FigureId["McB"] = "mcB";
    FigureId["TruckA"] = "truckA";
    FigureId["TruckB"] = "truckB";
})(FigureId || (FigureId = {}));
var FIGURE_OPTIONS = (_a = {},
    _a[FigureId.CarA] = { size: [25, 60] },
    _a[FigureId.CarB] = { size: [25, 60] },
    _a[FigureId.McA] = { size: [29, 60] },
    _a[FigureId.McB] = { size: [29, 60] },
    _a[FigureId.TruckA] = { size: [29, 60] },
    _a[FigureId.TruckB] = { size: [29, 60] },
    _a);
function getFigureOptions(figureId) {
    return FIGURE_OPTIONS[figureId];
}
var SketchActionCommand;
(function (SketchActionCommand) {
    SketchActionCommand["AddPolyline"] = "AddPolyline";
    SketchActionCommand["DeletePolyline"] = "DeletePolyline";
    SketchActionCommand["AddFigure"] = "AddFigure";
    SketchActionCommand["MoveFigure"] = "MoveFigure";
    SketchActionCommand["DeleteFigure"] = "DeleteFigure";
})(SketchActionCommand || (SketchActionCommand = {}));
var DEFAULT_BRUSH = ["black", 3];
function serializeBrush(brush) {
    return brush
        ? {
            color: brush[0],
            size: brush[1],
        }
        : null;
}
function parseBrush(brush) {
    return brush ? [brush.color, brush.size] : null;
}
var Common;
(function (Common) {
    function parsePolyline(polyline, b64toFloatArray) {
        if (!polyline.line)
            return null;
        var floatArray = b64toFloatArray(polyline.line);
        var array = Array.prototype.slice.call(floatArray);
        var decoded = [array, parseBrush(polyline.brush)];
        return decoded;
    }
    Common.parsePolyline = parsePolyline;
})(Common || (Common = {}));
function getPolylineElements(actions) {
    var addedPolylines = actions.filter(function (x) {
        return x.command === SketchActionCommand.AddPolyline;
    });
    var deletedPolylines = actions.filter(function (x) {
        return x.command === SketchActionCommand.DeletePolyline;
    });
    return addedPolylines
        .filter(function (x) { return !deletedPolylines.find(function (y) { return y.elementId === x.elementId; }); })
        .map(function (x) {
        var value = {
            line: x.addPolyline.line,
            brush: x.addPolyline.brush,
            created: x.created,
        };
        return { elementId: x.elementId, value: value };
    });
}
function getFigureElements(actions) {
    var addedFigures = actions.filter(function (x) { return x.command === SketchActionCommand.AddFigure; });
    var deletedFigures = actions.filter(function (x) {
        return x.command === SketchActionCommand.DeleteFigure;
    });
    var movedFigures = actions
        .filter(function (x) {
        return x.command === SketchActionCommand.MoveFigure;
    })
        .reverse();
    return addedFigures
        .filter(function (x) { return !deletedFigures.find(function (y) { return y.elementId === x.elementId; }); })
        .map(function (x) {
        var lastMovement = movedFigures.find(function (y) { return y.elementId === x.elementId; });
        var value = {
            figureId: x.addFigure.figureId,
            placement: lastMovement
                ? lastMovement.moveFigure.figurePlacement
                : x.addFigure.figurePlacement,
        };
        return {
            created: x.created,
            elementId: x.elementId,
            value: value,
        };
    });
}

var Browser;
(function (Browser) {
    function b64toFloatArray(str) {
        var blob = atob(str);
        var arrayBuffer = new ArrayBuffer(blob.length);
        var dataView = new DataView(arrayBuffer);
        for (var i = 0; i < blob.length; i++) {
            dataView.setUint8(i, blob.charCodeAt(i));
        }
        return new Float32Array(arrayBuffer);
    }
    function parsePolyline(polyline) {
        return Common.parsePolyline(polyline, b64toFloatArray);
    }
    Browser.parsePolyline = parsePolyline;
    function serializePolyline(polyline) {
        var str = btoa(String.fromCharCode.apply(String, Array.from(new Uint8Array(new Float32Array(polyline[0]).buffer))));
        return {
            line: str,
            brush: serializeBrush(polyline[1]),
        };
    }
    Browser.serializePolyline = serializePolyline;
})(Browser || (Browser = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function formatDateForDisplay(raw) {
    if (!raw)
        return "-";
    var yyyymmddPattern = /^(\d{4})-(\d{2})-(\d{2})$/;
    var match = raw.match(yyyymmddPattern);
    if (!match)
        return raw;
    return "".concat(match[3], ".").concat(match[2], ".").concat(match[1]);
}
function formatTimeForDisplay(raw) {
    if (!raw)
        return "-";
    var hhmmssPattern = /^(\d{2}):(\d{2}):(\d{2})$/;
    var match = raw.match(hhmmssPattern);
    if (!match)
        return raw;
    return "".concat(match[1], ":").concat(match[2]);
}

var ACCIDENT_QUESTIONS = {
    standardFields: {
        vehicleStill: {
            type: "options",
            options: [
                {
                    value: VehicleStill.Parked,
                    label: "Parkert",
                },
                { value: VehicleStill.Still, label: "Sto stille i kollisjonsøyeblikket" },
            ],
            pdfLabel: "\\*Parkert/\n\\*Sto stille i kollisjonsøyeblikket",
            label: "Var du parkert, eller stod stille, i kollisjonsøyeblikket?",
            placeholder: {
                label: "Ingen av delene",
                value: VehicleStill.NotApplicable,
            },
        },
        vehicleStarting: {
            type: "options",
            options: [
                { value: VehicleStarting.Starting, label: "Satt kjøretøyet i bevegelse" },
                { value: VehicleStarting.OpenedDoor, label: "Åpnet døra" },
            ],
            pdfLabel: "\\*Satt kjøretøyet i bevegelse/\n\\*Åpnet døra",
            label: "Åpnet du døra, eller satt du kjøretøyet i bevegelse i kollisjonsøyeblikket?",
            placeholder: {
                label: "Ingen av delene",
                value: VehicleStarting.NotApplicable,
            },
        },
        wasStopping: { type: "boolean", pdfLabel: "Var i ferd med å stoppe", label: "Jeg var i ferd med å stoppe" },
        exitingParking: {
            type: "boolean",
            pdfLabel: "Kjørte _ut_ fra parkeringsplass,\nprivat område, gårdsvei o.l.",
            label: "Jeg kjørte <em>ut</em> fra parkeringsplass, privat område, gårdsvei o.l.",
        },
        enteringParking: {
            type: "boolean",
            pdfLabel: "Kjørte _inn_ på parkeringsplass,\nprivat område, gårdsvei o.l.",
            label: "Jeg kjørte <em>inn</em> på parkeringsplass,\nprivat område, gårdsvei o.l.",
        },
        enteringRoundabout: {
            type: "boolean",
            pdfLabel: "Kjørte _inn_ i en rundkjøring",
            label: "Jeg kjørte <em>inn</em> i en rundkjøring",
        },
        exitingRoundabout: {
            type: "boolean",
            pdfLabel: "Kjørte _i_ en rundkjøring",
            label: "Jeg kjørte <em>i</em> en rundkjøring",
        },
        hitFromBehind: {
            type: "boolean",
            pdfLabel: "Kjørte på bakfra i samme retning\nog samme kjørefelt",
            label: "Jeg kjørte på bakfra i samme retning og samme kjørefelt",
        },
        drivingParallelLane: {
            type: "boolean",
            pdfLabel: "Kjørte i samme retning\ni annet kjørefelt",
            label: "Jeg kjørte i samme retning i annet kjørefelt",
        },
        changedLane: { type: "boolean", pdfLabel: "Skiftet kjørefelt", label: "Jeg skiftet kjørefelt" },
        wasPassing: { type: "boolean", pdfLabel: "Kjørte forbi", label: "Jeg kjørte forbi" },
        turnedRight: {
            type: "boolean",
            pdfLabel: "Svingte til _høyre_",
            label: "Jeg svingte til <em>høyre</em>",
        },
        turnedLeft: {
            type: "boolean",
            pdfLabel: "Svingte til _venstre_",
            label: "Jeg svingte til <em>venstre</em>",
        },
        wasBackingUp: { type: "boolean", pdfLabel: "Rygget", label: "Jeg rygget" },
        enteredWrongDirectionLane: {
            type: "boolean",
            pdfLabel: "Kom inn på del av veien bestemt\nfor trafikk i motsatt retning",
            label: "Jeg kom inn på del av veien bestemt for trafikk i motsatt retning",
        },
        cameFromRightAtIntersection: {
            type: "boolean",
            pdfLabel: "Kom fra høyre i et kryss",
            label: "Jeg kom fra høyre i et kryss",
        },
        ignoredRightOfWaySignalOrRedLight: {
            type: "boolean",
            pdfLabel: "Fulgte ikke varsel\nom vikeplikt eller rødt lys",
            label: "Jeg fulgte ikke varsel om vikeplikt eller rødt lys",
        },
    },
    derivedFields: {},
};
if (ACCIDENT_QUESTIONS.derivedFields) {
    ACCIDENT_QUESTIONS.derivedFields.sum = {
        label: "Antall avkryssede felt",
        dependencies: Object.keys(ACCIDENT_QUESTIONS.standardFields),
        transform: function (args) {
            return args.filter(function (x) { return x; }).length.toString();
        },
        type: "number",
    };
}
function join(fields) {
    return fields.filter(function (c) { return c; }).join(", ");
}
function uppercase(value) {
    return value.toUpperCase();
}
var ACCIDENT_DESCRIPTION = {
    standardFields: {
        date: {
            type: "date",
            label: "Skadedato",
            transform: formatDateForDisplay,
            validation: {
                isRequired: true,
            },
        },
        time: {
            type: "time",
            label: "Klokken",
            transform: formatTimeForDisplay,
            validation: {
                isRequired: true,
            },
        },
        location: {
            type: "text",
            label: "Sted",
            pdfLabel: "(gate/gatekryss, veinr. husnr. mest mulig eksakt)",
            placeholder: { label: "Kryss, gatenavn etc.", value: null },
            validation: {
                isRequired: true,
            },
        },
        county: {
            type: "text",
            label: "Kommune",
            placeholder: { label: "Kommune der hendelsen skjedde", value: null },
            validation: {
                isRequired: true,
            },
        },
        country: {
            type: "text",
            label: "Land",
            validation: {
                isRequired: true,
            },
        },
        injury: {
            type: "boolean",
            label: "Personskade",
            options: [
                { value: false, label: "Nei" },
                { value: true, label: "Ja" },
            ],
            description: "<p>Huk av om uhellet førte til personskade. Personskader skal meldes til politiet. Alle som er innblandet i eller kommer over en trafikkulykke er forpliktet til å stanse og hjelpe personer og dyr som er kommet til skade.</p>",
        },
        materialDamageOtherThanInvolvedVehicles: {
            type: "boolean",
            label: "Annen materiell skade enn på kjøretøy A og B",
            options: [
                { value: false, label: "Nei" },
                { value: true, label: "Ja" },
            ],
            description: "<p>Huk av om uhellet førte til materielle skader på andre ting enn kjøretøy A og B. (annen skadet gjenstand/eiendom/kjøretøy)</p>",
        },
        damageToNonVehicleObjects: {
            type: "boolean",
            label: "Skade på andre objekter enn kjøretøy",
            options: [
                { value: false, label: "Nei" },
                { value: true, label: "Ja" },
            ],
            description: "<p>Huk av om uhellet førte til materielle skader på andre ting enn kjøretøy. (annen skadet gjenstand/eiendom)</p>",
        },
    },
};
var genderField = {
    type: "options",
    options: [
        { value: Gender.Male, label: "Mann" },
        { value: Gender.Female, label: "Kvinne" },
    ],
    label: "Kjønn",
    placeholder: { label: "Ikke oppgitt", value: Gender.None },
};
var WITNESS = {
    derivedFields: {
        combinedWitnessDetails: {
            type: "text",
            dependencies: [
                "hadWitness",
                "phone",
                "fullName",
                "address",
                "postalCode",
                "city",
                "country",
                "passenger",
            ],
            label: "Detaljer",
            transform: function (_a) {
                var hadWitness = _a[0], phone = _a[1], fullName = _a[2], address = _a[3], postalCode = _a[4], city = _a[5], country = _a[6], passenger = _a[7];
                if (hadWitness !== true) {
                    return "";
                }
                var parts = [];
                if (fullName)
                    parts.push(fullName);
                if (phone)
                    parts.push("tlf. ".concat(phone));
                if (address)
                    parts.push(address);
                if (postalCode || city)
                    parts.push([postalCode, city].filter(function (p) { return p; }).join(" "));
                if (country)
                    parts.push(country);
                return (parts.join(", ") +
                    (passenger && passenger !== "None"
                        ? " (passasjer i kj\u00F8ret\u00F8y ".concat(passenger, ")")
                        : ""));
            },
        },
    },
    standardFields: {
        hadWitness: {
            type: "options",
            label: "Var det vitner tilstede?",
            options: [
                { value: false, label: "Nei" },
                { value: true, label: "Ja" },
            ],
        },
        phone: {
            label: "Mobilnummer",
            type: "text",
            completeLabel: "Vitnes mobilnummer",
            placeholder: { label: "Ditt mobilnummer", value: null },
        },
        fullName: {
            label: "Fullt navn",
            type: "text",
            completeLabel: "Vitnes navn",
            placeholder: { label: "Fornavn og etternavn", value: null },
        },
        address: {
            label: "Adresse",
            type: "text",
            completeLabel: "Vitnes adresse",
            placeholder: { label: "Gate, vei, gatenr.", value: null },
        },
        postalCode: {
            label: "Postnr.",
            type: "text",
            completeLabel: "Vitnes postnummer",
            placeholder: { label: "4 siffer", value: null },
        },
        city: {
            label: "Poststed",
            type: "text",
            completeLabel: "Vitnes poststed",
            placeholder: { label: "Sted", value: null },
        },
        country: {
            label: "Land",
            type: "text",
            completeLabel: "Vitnes land",
            placeholder: { label: "Velg land", value: null },
        },
        passenger: {
            label: "Vitnet var passasjer",
            type: "options",
            options: [
                {
                    value: VehicleKey.A,
                    label: "Kjøretøy A",
                },
                {
                    value: VehicleKey.B,
                    label: "Kjøretøy B",
                },
                {
                    value: "None",
                    label: "Var ikke passasjer",
                },
            ],
        },
    },
};
var INSUREE = {
    standardFields: {
        vatResponsible: {
            type: "boolean",
            pdfLabel: "Oppgave-pliktig for m.v.a",
            label: "Oppgavepliktig for mva.",
            description: "Gjelder dersom bilen er brukt av en virksomhet, selskap eller som firmabil.",
        },
        sameAsDriver: {
            type: "boolean",
            label: "Forsikringstakeren var fører av kjøretøyet",
            validation: { isRequired: true },
        },
        gender: __assign(__assign({}, genderField), { completeLabel: "Forsikringstakers kjønn" }),
    },
};
var CONTACT_INFO = {
    standardFields: {
        phone: {
            type: "phone",
            label: "Mobilnummer",
            placeholder: { label: "Ditt mobilnummer", value: null },
        },
        email: {
            type: "email",
            label: "E-postadresse",
            placeholder: { label: "E-post", value: null },
        },
        firstName: {
            type: "text",
            label: "Fornavn, mellomnavn",
            transform: uppercase,
            placeholder: { label: "Fornavn", value: null },
        },
        lastName: {
            type: "text",
            pdfLabel: "Etternavn (BRUK BLOKKBOKSTAVER)",
            label: "Etternavn",
            transform: uppercase,
            placeholder: { label: "Etternavn", value: null },
        },
        dateOfBirth: {
            label: "Fødselsdato",
            transform: formatDateForDisplay,
            type: "date",
        },
        address: {
            type: "text",
            label: "Adresse",
            transform: uppercase,
            placeholder: { label: "Gate, vei, gatenr.", value: null },
        },
        postalCode: {
            type: "postalCode",
            label: "Postnummer",
            placeholder: { label: "4 siffer", value: null },
        },
        city: {
            type: "text",
            label: "Poststed",
            placeholder: { label: "Sted", value: null },
        },
        country: {
            type: "text",
            label: "Land",
            placeholder: { label: "Velg land", value: null },
        },
    },
    derivedFields: {
        age: {
            type: "number",
            label: "Alder",
            dependencies: ["dateOfBirth"],
            transform: function (_a) {
                var date = _a[0];
                return date ? differenceInYears(new Date(), new Date(date)).toString() : null;
            },
        },
        postal: {
            type: "text",
            dependencies: ["postalCode", "city", "country"],
            label: "Postnr./-sted, land",
            transform: join,
        },
        fullName: {
            type: "text",
            label: "Etternavn, fornavn",
            dependencies: ["firstName", "lastName"],
            transform: function (_a) {
                var firstName = _a[0], lastName = _a[1];
                return [lastName, firstName].filter(function (c) { return c; }).join(", ");
            },
        },
    },
};
function cloneStandardFields(fields) {
    return Object.fromEntries(Object.entries(fields).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [
            key,
            __assign(__assign({}, value), { placeholder: value.placeholder ? __assign({}, value.placeholder) : undefined, validation: value.validation ? __assign({}, value.validation) : undefined, options: value.options ? __spreadArray([], value.options, true) : undefined }),
        ];
    }));
}
function cloneDerivedFields(fields) {
    if (!fields)
        return undefined;
    return Object.fromEntries(Object.entries(fields).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [
            key,
            __assign(__assign({}, value), { dependencies: __spreadArray([], value.dependencies, true) }),
        ];
    }));
}
function cloneFieldLabels(labels) {
    return {
        standardFields: cloneStandardFields(labels.standardFields),
        derivedFields: cloneDerivedFields(labels.derivedFields),
    };
}
var clonedContactInfoForDriver = cloneFieldLabels(CONTACT_INFO);
var DRIVER_CONTACT_INFO = {
    standardFields: __assign(__assign({}, clonedContactInfoForDriver.standardFields), { nationalIdentityNumber: {
            type: "text",
            label: "Fødselsnummer",
            placeholder: { label: "11 siffer", value: null },
        } }),
    derivedFields: clonedContactInfoForDriver.derivedFields,
};
function requireDriverContactInfo(key) {
    if (DRIVER_CONTACT_INFO.standardFields[key])
        DRIVER_CONTACT_INFO.standardFields[key].validation = { isRequired: true };
}
function driverContactInfoCompleteLabel(key, text) {
    if (DRIVER_CONTACT_INFO.standardFields[key])
        DRIVER_CONTACT_INFO.standardFields[key].completeLabel = text;
}
requireDriverContactInfo("phone");
requireDriverContactInfo("firstName");
requireDriverContactInfo("lastName");
requireDriverContactInfo("email");
requireDriverContactInfo("nationalIdentityNumber");
driverContactInfoCompleteLabel("phone", "Førers mobilnummer");
driverContactInfoCompleteLabel("email", "Førers e-postadresse");
driverContactInfoCompleteLabel("firstName", "Førers fornavn");
driverContactInfoCompleteLabel("lastName", "Førers etternavn");
driverContactInfoCompleteLabel("dateOfBirth", "Førers fødselsdato");
driverContactInfoCompleteLabel("address", "Førers adresse");
driverContactInfoCompleteLabel("postalCode", "Førers postnummer");
driverContactInfoCompleteLabel("city", "Førers poststed");
driverContactInfoCompleteLabel("country", "Førers land");
driverContactInfoCompleteLabel("nationalIdentityNumber", "Førers fødselsnummer");
var INSUREE_CONTACT_INFO = cloneFieldLabels(CONTACT_INFO);
function insureeContactInfoPlaceholder(key, text) {
    if (INSUREE_CONTACT_INFO.standardFields[key])
        INSUREE_CONTACT_INFO.standardFields[key].placeholder = {
            label: text,
            value: null,
        };
}
function insureeContactInfoCompleteLabel(key, text) {
    if (INSUREE_CONTACT_INFO.standardFields[key])
        INSUREE_CONTACT_INFO.standardFields[key].completeLabel = text;
}
insureeContactInfoPlaceholder("firstName", "Forsikringstakers fornavn");
insureeContactInfoPlaceholder("lastName", "Forsikringstakers etternavn");
insureeContactInfoPlaceholder("email", "Forsikringstakers e-post");
insureeContactInfoCompleteLabel("phone", "Forsikringstakers mobilnummer");
insureeContactInfoCompleteLabel("email", "Forsikringstakers e-postadresse");
insureeContactInfoCompleteLabel("firstName", "Forsikringstakers fornavn");
insureeContactInfoCompleteLabel("lastName", "Forsikringstakers etternavn");
insureeContactInfoCompleteLabel("dateOfBirth", "Forsikringstakers fødselsdato");
insureeContactInfoCompleteLabel("address", "Forsikringstakers adresse");
insureeContactInfoCompleteLabel("postalCode", "Forsikringstakers postnummer");
insureeContactInfoCompleteLabel("city", "Forsikringstakers poststed");
insureeContactInfoCompleteLabel("country", "Forsikringstakers land");
var VEHICLE_DATA = {
    standardFields: {
        licensePlateNumber: {
            type: "text",
            pdfLabel: "Kjennetegn (reg nr.)",
            label: "Registreringsnummer",
            placeholder: { label: "Ditt registreringsnummer", value: null },
        },
        manufactureName: {
            type: "text",
            pdfLabel: "Merke",
            label: "Merke / Type",
            placeholder: { label: "F.eks. Tesla, Volkswagen...", value: null },
        },
        modelName: {
            type: "text",
            pdfLabel: "Modellnavn",
            label: "Modell",
            placeholder: { label: "F.eks. Model X, Golf...", value: null },
        },
        registrationCountry: { type: "text", label: "Registreringsland" },
    },
    derivedFields: {
        makeModel: {
            type: "text",
            dependencies: ["manufactureName", "modelName"],
            label: "Merke/Type",
            transform: join,
        },
    },
};
var clonedVehicleDataForTrailer = cloneFieldLabels(VEHICLE_DATA);
var TRAILER_DATA = {
    standardFields: __assign({ hasTrailer: {
            type: "boolean",
            options: [
                { value: false, label: "Nei" },
                { value: true, label: "Ja" },
            ],
            label: "Hadde kjøretøyet tilhenger?"
        } }, clonedVehicleDataForTrailer.standardFields),
    derivedFields: clonedVehicleDataForTrailer.derivedFields,
};
function trailerDataPlaceholder(key, text) {
    if (TRAILER_DATA.standardFields[key])
        TRAILER_DATA.standardFields[key].placeholder = {
            label: text,
            value: null,
        };
}
function trailerDataCompleteLabel(key, text) {
    if (TRAILER_DATA.standardFields[key])
        TRAILER_DATA.standardFields[key].completeLabel = text;
}
trailerDataPlaceholder("licensePlateNumber", "Registreringsnummer");
trailerDataPlaceholder("manufactureName", "F.eks Tredal, Gaupen...");
trailerDataPlaceholder("modelName", "F.eks T-75-BK, F0620... ");
trailerDataCompleteLabel("licensePlateNumber", "Tilhengers registreringsnummer");
trailerDataCompleteLabel("manufactureName", "Tilhengers merke");
trailerDataCompleteLabel("modelName", "Tilhengers modell");
var INSURANCE = {
    standardFields: {
        companyName: {
            type: "text",
            pdfLabel: "Navn",
            label: "Forsikringsselskap",
            placeholder: {
                label: "Navn på forsikringsselskapet",
                value: null,
            },
        },
        agreementNumber: {
            type: "text",
            label: "Forsikringsavtalenummer",
            placeholder: { label: "Ditt forsikringsavtalenummer", value: null },
        },
        greenCardNumber: {
            type: "text",
            pdfLabel: "Grønt kort nr. (skade utenfor Norden)",
            label: "Grønt kort nummer",
            description: "<p>Grønt kort er et internasjonalt forsikringskort som bekrefter at du har gyldig ansvarsforsikring. Grønt kort kan lette situasjonen dersom du opplever et trafikkuhell og må bevise at du har gyldig forsikring.</p>",
        },
        greenCardExpirationDate: {
            type: "date",
            pdfLabel: "Gyldig til dato",
            label: "Gyldig til",
            transform: formatDateForDisplay,
        },
        comprehensiveInsurance: {
            type: "boolean",
            pdfLabel: "Kasko-forsikring",
            label: "Kaskoforsikring",
            placeholder: { label: "Ikke oppgitt", value: null },
        },
    },
};
var DRIVER = {
    standardFields: {
        driversLicenseNumber: {
            type: "text",
            label: "Førerkortnummer",
            placeholder: { label: "Punkt 5 på det fysiske førerkortet", value: null }
        },
        driversLicenseClass: {
            type: "text",
            label: "Klasse",
            completeLabel: "Førerkortklasse",
            placeholder: { label: "B, B 96 osv.", value: null },
        },
        issueDate: {
            type: "text",
            label: "Utstedt dato",
            completeLabel: "Førerkort utstedt dato",
            transform: formatDateForDisplay,
        },
        expirationDate: {
            type: "text",
            label: "Gyldig til",
            completeLabel: "Førerkort gyldig til",
            transform: formatDateForDisplay,
        },
        gender: __assign(__assign({}, genderField), { completeLabel: "Førerkortholders kjønn" }),
    },
};
var COLLISION_TOUCH = {
    standardFields: {
        type: {
            type: "text",
            label: "Kjøretøystype",
            options: [
                { label: "MC", value: CollisionTouchType.MC },
                { label: "Personbil", value: CollisionTouchType.Car },
                { label: "Stor bil", value: CollisionTouchType.Trailer },
            ],
            placeholder: { label: "Velg kjøretøystype", value: CollisionTouchType.None },
        },
        // The X and Y labels are overridden in the updates view (ReportUpdatesList.tsx)
        x: {
            type: "number",
            label: "Posisjon",
        },
        y: {
            type: "number",
            label: "Posisjon",
        },
    },
};
var DAMAGE_DESCRIPTION = {
    standardFields: {
        text: {
            type: "text",
            label: "Synlige skader på kjøretøyet fra hendelsen",
            placeholder: {
                label: "Beskriv kort synlige skader på kjøretøyet fra hendelsen",
                value: null,
            },
            validation: { maxLength: 400 },
        },
    },
};
var COMMENTS = {
    standardFields: {
        text: {
            type: "text",
            label: "Bemerkninger/eventuelle forbehold ved uenighet",
            pdfLabel: "Bemerkninger / eventuelle forhold v/uenighet",
            description: "Dersom det er uenighet om detaljer på skademeldingen ta forbehold om dette her.",
            placeholder: { label: "F.eks. jeg er uenig i motpartens påstand i pkt.10", value: null }
        },
    },
};
function isVehicleField(x) {
    return "vehicleField" in x && x.vehicleField;
}
function isPageTwoField(x) {
    return "pageTwoField" in x && x.pageTwoField;
}
var StandardCommonFieldSpecification = /** @class */ (function () {
    function StandardCommonFieldSpecification(section, key) {
        this.section = section;
        this.key = key;
    }
    return StandardCommonFieldSpecification;
}());
var DerivedCommonFieldSpecification = /** @class */ (function () {
    function DerivedCommonFieldSpecification(section, derivedKey) {
        this.section = section;
        this.derivedKey = derivedKey;
    }
    return DerivedCommonFieldSpecification;
}());
var StandardVehicleFieldSpecification = /** @class */ (function () {
    function StandardVehicleFieldSpecification(section, key) {
        this.section = section;
        this.key = key;
        this.vehicleField = true;
    }
    return StandardVehicleFieldSpecification;
}());
var DerivedVehicleFieldSpecification = /** @class */ (function () {
    function DerivedVehicleFieldSpecification(section, derivedKey) {
        this.section = section;
        this.derivedKey = derivedKey;
        this.vehicleField = true;
    }
    return DerivedVehicleFieldSpecification;
}());
var StandardPageTwoFieldSpecification = /** @class */ (function () {
    function StandardPageTwoFieldSpecification(section, key) {
        this.section = section;
        this.key = key;
        this.pageTwoField = true;
    }
    return StandardPageTwoFieldSpecification;
}());
var DerivedPageTwoFieldSpecification = /** @class */ (function () {
    function DerivedPageTwoFieldSpecification(section, derivedKey) {
        this.section = section;
        this.derivedKey = derivedKey;
        this.pageTwoField = true;
    }
    return DerivedPageTwoFieldSpecification;
}());
function vehicleField(section, key) {
    return new StandardVehicleFieldSpecification(section, key);
}
function derivedVehicleField(section, key) {
    return new DerivedVehicleFieldSpecification(section, key);
}
function pageTwoField(section, key) {
    return new StandardPageTwoFieldSpecification(section, key);
}
function derivedPageTwoField(section, key) {
    return new DerivedPageTwoFieldSpecification(section, key);
}
function commonField(section, key) {
    return new StandardCommonFieldSpecification(section, key);
}
function derivedCommonField(section, key) {
    return new DerivedCommonFieldSpecification(section, key);
}
var SUPPLEMENTAL_INFO = {
    standardFields: {
        startVelocity: {
            label: "Da situasjonen oppsto",
            type: "number",
            suffix: "Km/t",
        },
        collisionVelocity: {
            label: "I kollisjonsøyeblikket",
            pdfLabel: "I kollisjons-øyeblikket",
            type: "number",
            suffix: "Km/t",
        },
        speedLimit: {
            label: "Fartsgrense på stedet",
            type: "number",
            suffix: "Km/t",
        },
        surface: {
            label: "Veidekke",
            type: "optionsMultiple",
            options: [
                {
                    label: "Fast dekke",
                    value: "Solid",
                },
                {
                    label: "Grus",
                    value: "Gravel",
                },
            ],
        },
        condition: {
            label: "Føre",
            type: "optionsMultiple",
            options: [
                {
                    label: "Tørt",
                    value: "Dry",
                },
                {
                    label: "Vått",
                    value: "Wet",
                },
                {
                    label: "Snø/is",
                    value: "SnowOrIce",
                },
            ],
        },
        weather: {
            label: "Værforhold",
            type: "optionsMultiple",
            options: [
                {
                    label: "Opphold",
                    value: "DryWeather",
                },
                {
                    label: "Regn",
                    value: "Rain",
                },
                {
                    label: "Snø",
                    value: "Snow",
                },
                {
                    label: "Tåke",
                    value: "Fog",
                },
            ],
        },
        equipmentUsed: {
            label: "Utstyr som var i bruk",
            type: "optionsMultiple",
            options: [
                {
                    label: "Kjettinger",
                    value: "Chains",
                },
                {
                    label: "Vinterdekk uten pigger",
                    value: "StudlessWinterTires",
                },
                {
                    label: "Piggdekk",
                    value: "StuddetTires",
                },
                {
                    label: "Sommerdekk",
                    value: "SummerTires",
                },
            ],
        },
        temperature: {
            label: "Temperatur (ca.)",
            type: "number",
            suffix: "°C",
        },
        lightConditions: {
            label: "Lysforhold",
            type: "optionsMultiple",
            options: [
                {
                    label: "Dagslys",
                    value: "Daylight",
                },
                {
                    label: "Skumring",
                    value: "Dawn",
                },
                {
                    label: "Mørkt",
                    value: "Dark",
                },
                {
                    label: "Gatelys tent",
                    value: "StreetLights",
                },
            ],
        },
        lightsUsed: {
            label: "Lys som var i bruk",
            type: "optionsMultiple",
            options: [
                {
                    label: "Fjernlys",
                    value: "FarLights",
                },
                {
                    label: "Nærlys",
                    value: "NearLights",
                },
                {
                    label: "Parklys",
                    value: "ParkingLights",
                },
                {
                    label: "Ekstralys",
                    value: "ExtraLights",
                },
                {
                    label: "Brukte ikke lys",
                    value: "None",
                },
            ],
        },
        signal: {
            label: "Signal gitt med",
            type: "optionsMultiple",
            options: [
                {
                    label: "Blinklys",
                    value: "TurningLights",
                },
                {
                    label: "Horn",
                    value: "Horn",
                },
                {
                    label: "Lys",
                    value: "Lights",
                },
            ],
        },
        responsible: {
            label: "Ansvarlig",
            type: "optionsMultiple",
            description: "Hvem var etter din mening ansvaring for skadene?",
            options: [
                {
                    label: "Fører A",
                    value: VehicleKey.A,
                },
                {
                    label: "Fører B",
                    value: VehicleKey.B,
                },
                {
                    label: "Annen",
                    value: "Other",
                },
                {
                    label: "Vet ikke",
                    value: "Unknown",
                },
            ],
        },
        businessVehicle: {
            label: "Bilen ble benyttet i næring",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        driverIntoxicated: {
            label: "Hadde føreren inntatt akohol/rusmidler/trafikkfarlige midler?",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        substances: {
            label: "Hvis ja, kryss av for:",
            type: "optionsMultiple",
            options: [
                {
                    label: "Alkohol",
                    value: "Alcohol",
                },
                {
                    label: "Andre rusmidler",
                    value: "OtherSubstances",
                },
                {
                    label: "Legemidler",
                    value: "Drugs",
                },
            ],
        },
        bloodTested: {
            label: "Utåndings-/blodprøve tatt",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        mileage: {
            label: "Kilometerstand",
            type: "number",
            suffix: "Km",
        },
        roadAssistanceCalled: {
            label: "Er bilredningsfirma tilkalt?",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        roadAssistanceCompany: {
            label: "Hvis ja, hvilket firma?",
            type: "text",
            placeholder: { label: "F.eks: NAF", value: null },
        },
        materialDamageOtherThanInvolvedVehicles: {
            label: "Annen <em>materiell</em> skade enn på kjøretøy A og B (skadet gjenstand/eiendom)",
            pdfLabel: "Annen materiell skade enn på kjøretøy A og B",
            type: "text",
            placeholder: { label: "Skriv her", value: null },
        },
        previousDamage: {
            label: "Tidligere skader",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        previousDamageDescription: {
            label: "Hvis ja, gi en kort beskrivelse",
            type: "text",
            placeholder: { label: "Skriv her", value: null },
        },
        policeCase: {
            label: "Behandles saken hos politiet?",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
            placeholder: { label: "Ikke oppgitt", value: null },
        },
        policeDistrict: {
            label: "Hvis ja, hvilket politidistrikt?",
            type: "text",
            placeholder: { label: "Politidistrikt", value: null },
        },
        // PDF only
        injuriesInOtherVehicle: {
            label: "Skadet person i motpartens kjøretøy",
            type: "boolean",
            options: [
                {
                    value: true,
                    label: "Ja",
                },
                {
                    value: false,
                    label: "Nei",
                },
            ],
        },
        numInjuredPersonsInOtherVehicle: {
            label: "Hvis ja, hvor mange?",
            type: "number",
        },
        confirmation: {
            label: "Ved innsendelse av skademeldingen bekrefter jeg at opplysningene gitt er korrekte",
            type: "boolean",
        },
    },
};
var PAGE_TWO_ACCIDENT_DESCRIPTION = {
    standardFields: {
        text: {
            type: "text",
            label: "Beskriv så nøye som mulig hva som har skjedd og hva du selv gjorde før og etter hendelsen.",
            placeholder: { label: "Skriv her", value: null },
        },
    },
};
// Keeping this Injuree code, since it is used in the PDF generation, but it is not part of the form due to privacy concerns.
var INJUREE = {
    standardFields: {
        role: {
            type: "optionsMultiple",
            label: "",
            options: [
                {
                    label: "Fører",
                    value: "Driver",
                },
                {
                    label: "Passasjer",
                    value: "Pasenger",
                },
                {
                    label: "Fotgjenger",
                    value: "Pedestrian",
                },
                {
                    label: "Syklist",
                    value: "Cyclist",
                },
            ],
        },
        securityEquipmentUsed: {
            type: "optionsMultiple",
            label: "Sikring",
            options: [
                {
                    label: "Bilbelte",
                    value: "Belt",
                },
                {
                    label: "Kollisjonspute",
                    value: "CrashPad",
                },
                {
                    label: "Barnesikring",
                    value: "BoosterSeat",
                },
                {
                    label: "Hjelm",
                    value: "Helmet",
                },
                {
                    label: "Ingen",
                    value: "None",
                },
            ],
        },
        treatment: {
            type: "optionsMultiple",
            label: "Behandling",
            options: [
                {
                    label: "Omkommet",
                    value: "Deceased",
                },
                {
                    label: "Innlagt på sykehus",
                    value: "Hospitalized",
                },
                {
                    label: "Legebehandlet",
                    value: "TreatedByMedicalProfessional",
                },
            ],
        },
        hospital: {
            type: "text",
            label: "Behandlet av lege/sykehus",
            placeholder: { label: "Navn på lege/sykehus", value: null },
        },
    },
};
var PAGE_TWO_STATUS = {
    standardFields: {
        isComplete: {
            type: "boolean",
            label: "Side to ferdig",
        },
    },
};
var VEHICLE_REPORT_STATUS = {
    standardFields: {
        isComplete: {
            type: "boolean",
            label: "Jeg er ferdig med min del",
        },
        updated: {
            type: "date",
            label: "Sist endret",
        },
    },
};
var DAMAGED_PROPERTY_OWNER_CONTACT_INFO = {
    standardFields: __assign({}, CONTACT_INFO.standardFields),
    derivedFields: {
        nameAndAddress: {
            label: "Eierens navn og adresse",
            dependencies: [
                "firstName",
                "lastName",
                "address",
                "postalCode",
                "city",
                "country",
            ],
            type: "text",
            transform: function (_a) {
                var firstName = _a[0], lastName = _a[1], parts = _a.slice(2);
                var name = [firstName, lastName].filter(function (x) { return x; }).join(" ");
                var address = parts.filter(function (p) { return p; }).join(", ");
                return [name, address].filter(function (p) { return p; }).join(", ");
            },
        },
    },
};
var INJUREE_CONTACT_INFO = {
    standardFields: __assign(__assign({}, CONTACT_INFO.standardFields), { gender: genderField }),
    derivedFields: __assign({}, CONTACT_INFO.derivedFields),
};
var EntityType;
(function (EntityType) {
    EntityType["Single"] = "Single";
    EntityType["List"] = "List";
})(EntityType || (EntityType = {}));
var Schema = /** @class */ (function () {
    function Schema() {
        this.vehicleFieldSections = {
            insuree: INSUREE,
            insureeContactInfo: INSUREE_CONTACT_INFO,
            driverContactInfo: DRIVER_CONTACT_INFO,
            vehicleData: VEHICLE_DATA,
            trailerData: TRAILER_DATA,
            insurance: INSURANCE,
            driver: DRIVER,
            accidentQuestions: ACCIDENT_QUESTIONS,
            collisionTouch: COLLISION_TOUCH,
            damageDescription: DAMAGE_DESCRIPTION,
            comments: COMMENTS,
            witness: WITNESS,
            status: VEHICLE_REPORT_STATUS,
        };
        this.commonSections = {
            accidentDescription: ACCIDENT_DESCRIPTION,
        };
        this.pageTwoSections = {
            supplementalInfo: { type: EntityType.Single, section: SUPPLEMENTAL_INFO },
            damagedPropertyOwner: {
                type: EntityType.Single,
                section: DAMAGED_PROPERTY_OWNER_CONTACT_INFO,
            },
            accidentDescription: {
                type: EntityType.Single,
                section: PAGE_TWO_ACCIDENT_DESCRIPTION,
            },
            injureeContactInfo: {
                type: EntityType.List,
                section: INJUREE_CONTACT_INFO,
            },
            injuree: { type: EntityType.List, section: INJUREE },
            status: { type: EntityType.Single, section: PAGE_TWO_STATUS },
        };
    }
    Schema.prototype.getSection = function (field) {
        if (isVehicleField(field)) {
            var sectionDefintions_1 = this.vehicleFieldSections[field.section];
            if ("key" in field) {
                var section_1 = sectionDefintions_1.standardFields;
                return {
                    section: section_1,
                    sectionName: field.section,
                    name: field.key,
                    type: EntityType.Single,
                };
            }
            var section_2 = sectionDefintions_1.derivedFields;
            return {
                section: section_2,
                sectionName: field.section,
                name: field.derivedKey,
                type: EntityType.Single,
            };
        }
        if (isPageTwoField(field)) {
            var sectionDefintions_2 = this.pageTwoSections[field.section];
            if ("key" in field) {
                var section_3 = sectionDefintions_2.section.standardFields;
                return {
                    section: section_3,
                    sectionName: field.section,
                    name: field.key,
                    type: sectionDefintions_2.type,
                };
            }
            var section_4 = sectionDefintions_2.section.derivedFields;
            return {
                section: section_4,
                sectionName: field.section,
                name: field.derivedKey,
                type: sectionDefintions_2.type,
            };
        }
        var sectionDefintions = this.commonSections[field.section];
        if ("key" in field) {
            var section_5 = sectionDefintions.standardFields;
            return {
                section: section_5,
                sectionName: field.section,
                name: field.key,
                type: EntityType.Single,
            };
        }
        var section = sectionDefintions.derivedFields;
        return {
            section: section,
            sectionName: field.section,
            name: field.derivedKey,
            type: EntityType.Single,
        };
    };
    Schema.prototype.getDefinition = function (field) {
        var _a = this.getSection(field), section = _a.section, sectionName = _a.sectionName, name = _a.name, type = _a.type;
        return {
            section: sectionName,
            name: name,
            // biome-ignore lint/suspicious/noExplicitAny: <explanation>
            definition: section[name],
            type: type,
        };
    };
    Schema.prototype.getDisplayValue = function (field, report, request) {
        var _a = this.getDefinition(field), key = _a.name, definition = _a.definition, type = _a.type;
        var sections = [];
        if (isVehicleField(field)) {
            if (!(request && "vehicle" in request)) {
                throw new Error("Vehicle is required to get value for vehicle fields");
            }
            var vehicle = request.vehicle;
            sections.push(vehicle[field.section]);
        }
        else if (isPageTwoField(field)) {
            if (!(request && "pageTwo" in request)) {
                throw new Error("PageTwo is required to get value for page two fields");
            }
            var pageTwo = request.pageTwo;
            var sectionElement = pageTwo[field.section];
            if (sectionElement && "length" in sectionElement) {
                sections = sectionElement;
            }
            else {
                sections.push(sectionElement);
            }
        }
        else {
            sections = [report[field.section]];
        }
        sections = sections.filter(function (x) { return x; });
        var results = sections.map(function (section) {
            if ("dependencies" in definition) {
                var keys = definition.dependencies;
                // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                return definition.transform(keys.map(function (key) { return section[key]; }));
            }
            // biome-ignore lint/suspicious/noExplicitAny: <explanation>
            var value = section[key];
            if (definition.transform && value)
                return definition.transform(value);
            if (value === null || value === undefined)
                return null;
            return value;
        });
        return type === EntityType.Single
            ? { type: type, result: results[0] }
            : { type: type, result: results };
    };
    return Schema;
}());
function createSchema() {
    return new Schema();
}

var SectionParent;
(function (SectionParent) {
    SectionParent["Vehicle"] = "Vehicle";
    SectionParent["PageTwo"] = "PageTwo";
    SectionParent["Common"] = "Common";
})(SectionParent || (SectionParent = {}));

// The pdf dimensions where previously calculated by taking the available width and height,
// and rounding down to the nearest multiple of 12, which gave the numbers below.
// This is now replaced by hard coded values, since the frontend and other parts of PDF generation
// needs to know the aspect ratio ahead of time.
// Changing these values can make the generated PDF very ugly, and it will also affect the frontend, test thoroughly
var pdfCanvasWidth = 348;
var pdfCanvasHeight = 156;
var canvasAspectRatio = pdfCanvasWidth / pdfCanvasHeight;
var browserCanvasWidth = 720;
var browserCanvasHeight = browserCanvasWidth / canvasAspectRatio;
var pdfToBrowserCanvasScale = pdfCanvasWidth / browserCanvasWidth;

export { AccidentReportPage, AutoFillSourceContact, AutoFillSourceVehicle, Browser, CollisionTouchType, Common, DEFAULT_BRUSH, DerivedCommonFieldSpecification, DerivedPageTwoFieldSpecification, DerivedVehicleFieldSpecification, DocumentSignatureSectionType, EntityType, FigureId, Gender, MessageMedium, Schema, SectionParent, SignatureStatus, SigningMethod, SketchActionCommand, StandardCommonFieldSpecification, StandardPageTwoFieldSpecification, StandardVehicleFieldSpecification, VehicleKey, VehicleStarting, VehicleStill, browserCanvasHeight, browserCanvasWidth, canvasAspectRatio, commonField, createSchema, derivedCommonField, derivedPageTwoField, derivedVehicleField, formatDateForDisplay, formatTimeForDisplay, getFigureElements, getFigureOptions, getPolylineElements, pageTwoField, parseBrush, pdfCanvasHeight, pdfCanvasWidth, pdfToBrowserCanvasScale, serializeBrush, vehicleField };
//# sourceMappingURL=browser.js.map
